import React from 'react';
import ReactDOM from 'react-dom';
import Register from '../components/Register';
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderRegister = (elementId, props, country) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<Register props={props} country={country} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering Register:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};